export default __webpack_public_path__ + "static/media/AchrafAtoini.83d3846c.png";